import { Component, EventEmitter, Input, Output, OnChanges, Inject, ViewChild, SimpleChanges } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { DatePickerComponent } from '../../../shared/datepicker/datepicker.component';

import * as moment from 'moment';
import { mapKeys, snakeCase } from 'lodash';
import { objectToHttpParams } from '../../../util';

@Component({
  selector: 'reason-form-date',
  template: `
    <div class="answer-wrapper">
      <datepicker #datePicker
        [disabled]="fetchDateOfLastAppointmentSucceeded"
        [(date)]="answer.date"
        [clearable]="!fetchDateOfLastAppointmentSucceeded"
        [placeholder]="'datepicker.placeholder' | translate"
        [min]="min"
        [max]="max"
        (dateChange)="this.validationChange.emit(!!$event)"></datepicker>
    </div>
  `,
})

export class ReasonFormDateComponent implements OnChanges {
  @Input() question: any;
  @Input() answer: any;
  @Input() min: moment.Moment;
  @Input() max: moment.Moment;
  @Input() taskId: number;
  @Input() reasonId: number;
  @Input() patientId: number;
  @Output() validationChange = new EventEmitter();

  @ViewChild('datePicker') datePicker: DatePickerComponent;

  public fetchDateOfLastAppointmentSucceeded: boolean = false;

  private apiEndpoint  = '/api/v2/appointment';

  constructor(
    public http: HttpClient,
    @Inject('$ngRedux') public $ngRedux: any,
    @Inject('$state') public $state: any,
  ) {}

  setDateOfLastAppointment = (date) => {
    if (date && date.startTime) {
      this.datePicker.setDate(moment(date.startTime));
      this.fetchDateOfLastAppointmentSucceeded = true;
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['question'] && changes['question'].currentValue.kind === 'date_of_last_appointment') {

      let params = {
        patientId: this.patientId,
        taskId: this.taskId,
        reasonId: this.reasonId,
      };

      params = mapKeys(params, (value, key) => (snakeCase(key))) as any;

      this.http.get(`${this.apiEndpoint}/appointment_date/latest`, { params: objectToHttpParams(params) })
          .map(response => response)
          .subscribe(this.setDateOfLastAppointment);
    }
  }
}



// WEBPACK FOOTER //
// ../node_modules/angular2-template-loader!./ng2/main/reasons/reason-form/reason-form-date.component.ts